import PropTypes from "prop-types"
import React, { useState } from "react"
import MetaTags from "react-meta-tags"
import QRCode from "../../assets/images/QRCode/QRCode.png"
import {
  Container,
  Row,
  Col,
  Button,
  Card,
  CardBody,
  Input,
  Dropdown,
  DropdownToggle,
  Modal,
  Label,
  Table,
  DropdownItem,
  DropdownMenu,
} from "reactstrap"
import { Link } from "react-router-dom"

// Custom Scrollbar
import SimpleBar from "simplebar-react"

// import images
import servicesIcon1 from "../../assets/images/services-icon/01.png"
import servicesIcon2 from "../../assets/images/services-icon/02.png"
import servicesIcon3 from "../../assets/images/services-icon/03.png"
import servicesIcon4 from "../../assets/images/services-icon/04.png"
import user2 from "../../assets/images/users/user-2.jpg"
import user3 from "../../assets/images/users/user-3.jpg"
import user4 from "../../assets/images/users/user-4.jpg"
import user5 from "../../assets/images/users/user-5.jpg"
import user6 from "../../assets/images/users/user-6.jpg"
import smimg1 from "../../assets/images/small/img-1.jpg"
import smimg2 from "../../assets/images/small/img-2.jpg"

// Charts
import LineAreaChart from "../AllCharts/apex/lineareachart"
import RadialChart from "../AllCharts/apex/apexdonut"
import Apexdonut from "../AllCharts/apex/apexdonut1"
import SparkLine from "../AllCharts/sparkline/sparkline"
import SparkLine1 from "../AllCharts/sparkline/sparkline1"
import Salesdonut from "../AllCharts/apex/salesdonut"

import "chartist/dist/scss/chartist.scss"

//i18n
import { withTranslation } from "react-i18next"

const Dashboard = props => {
  const [menu, setMenu] = useState(false)
  const toggle = () => {
    setMenu(!menu)
  }

  const [modal_center_1, setmodal_center_1] = useState(false)

  function view_ModelView() {
    setmodal_center_1(!modal_center_1)
    removeBodyCss()
  }

  function removeBodyCss() {
    document.body.classList.add("no_padding")
  }
  return (
    <React.Fragment>
      <div className="page-content">
        <MetaTags>
          <title>Dashboard | Virtual Supermarket</title>
        </MetaTags>
        <Container fluid>
          <div className="page-title-box">
            <Row className="align-items-center">
              <Col md={8}>
                <h4 className="page-title">Dashboard</h4>
                <ol className="breadcrumb m-0">
                  <li className="breadcrumb-item active">
                    Welcome to Virtual Supermarket Dashboard
                  </li>
                </ol>
              </Col>

              <Col md="4">
                <div className="float-end d-none d-md-block">
                  <Dropdown isOpen={menu} toggle={toggle}>
                    <DropdownToggle
                      color="primary"
                      className="btn btn-primary dropdown-toggle waves-effect waves-light"
                    >
                      <i className="mdi mdi-cog me-2"></i> Settings
                    </DropdownToggle>
                    <DropdownMenu right>
                      <DropdownItem tag="a" href="#">
                        Action
                      </DropdownItem>
                      <DropdownItem tag="a" href="#">
                        Another action
                      </DropdownItem>
                      <DropdownItem tag="a" href="#">
                        Something else here
                      </DropdownItem>
                      <DropdownItem divider />
                      <DropdownItem tag="a" href="#">
                        Separated link
                      </DropdownItem>
                    </DropdownMenu>
                  </Dropdown>
                </div>
              </Col>
            </Row>
          </div>
          <Row>
            <Card className="bg-dashboard">
              <CardBody>
                <Row>
                  <h5 className="page-title mb-3">Product Management</h5>
                  <Col xl={3} md={6}>
                    <Card className="mini-stat bg-primary text-white">
                      <CardBody>
                        <div className="">
                          <div className="float-start mini-stat-img me-4">
                            <img src={servicesIcon1} alt="" />
                          </div>
                          <Link to="/product-management">
                            <h5
                              className="font-size-14 text-uppercase mt-0 text-white-70"
                              style={{ height: "30px" }}
                            >
                              Products List
                            </h5>
                          </Link>
                          <h4 className="fw-medium font-size-24">589 </h4>
                        </div>
                      </CardBody>
                    </Card>
                  </Col>

                  <Col xl={3} md={6}>
                    <Card className="mini-stat bg-primary text-white">
                      <CardBody>
                        <div className="">
                          <div className="float-start mini-stat-img me-4">
                            <img src={servicesIcon2} alt="" />
                          </div>
                          <Link to="/offers">
                            <h5
                              className="font-size-14 text-uppercase mt-0 text-white-70"
                              style={{ height: "30px" }}
                            >
                              Offers
                            </h5>
                          </Link>
                          <h4 className="fw-medium font-size-24">368 </h4>
                        </div>
                      </CardBody>
                    </Card>
                  </Col>

                  <Col xl={3} md={6}>
                    <Card className="mini-stat bg-primary text-white">
                      <CardBody>
                        <div className="">
                          <div className="float-start mini-stat-img me-4">
                            <img src={servicesIcon3} alt="" />
                          </div>
                          <Link to="/last-minute-deal">
                            <h5
                              className="font-size-14 text-uppercase mt-0 text-white-70"
                              style={{ height: "30px" }}
                            >
                              Last-Minute Deals
                            </h5>
                          </Link>
                          <h4 className="fw-medium font-size-24">589 </h4>
                        </div>
                      </CardBody>
                    </Card>
                  </Col>

                  <Col xl={3} md={6}>
                    <Card className="mini-stat bg-primary text-white">
                      <CardBody>
                        <div className="">
                          <div className="float-start mini-stat-img me-4">
                            <img src={servicesIcon4} alt="" />
                          </div>
                          <Link to="/today's-order">
                          <h5
                            className="font-size-14 text-uppercase mt-0 text-white-70"
                            style={{ height: "30px" }}
                          >
                            Today's Order
                          </h5>
                          </Link>
                          <h4 className="fw-medium font-size-24">
                            589{" "}
                          </h4>
                        </div>
                      </CardBody>
                    </Card>
                  </Col>
                </Row>
              </CardBody>
            </Card>
          </Row>

          <Row>
            <Card className="bg-dashboard1">
              <CardBody>
                <Row>
                  <h5 className="page-title mb-3">Customers</h5>
                  <Col xl={3} md={6}>
                    <Card className="mini-stat bg-primary text-white">
                      <CardBody>
                        <div className="">
                          <div className="float-start mini-stat-img me-4">
                            <img src={servicesIcon1} alt="" />
                          </div>
                          <Link to="customers">
                            <h5
                              className="font-size-14 text-uppercase mt-0 text-white-70"
                              style={{ height: "30px" }}
                            >
                              Customers
                            </h5>
                          </Link>
                          <h4 className="fw-medium font-size-24">589 </h4>
                        </div>
                      </CardBody>
                    </Card>
                  </Col>

                  <Col xl={3} md={6}>
                    <Card className="mini-stat bg-primary text-white">
                      <CardBody>
                        <div className="">
                          <div className="float-start mini-stat-img me-4">
                            <img src={servicesIcon2} alt="" />
                          </div>
                          <h5
                            className="font-size-14 text-uppercase mt-0 text-white-70"
                            style={{ height: "30px" }}
                          >
                            Complaint
                          </h5>
                          <h4 className="fw-medium font-size-24">
                            368{" "}
                            {/* <i className="mdi mdi-arrow-down text-danger ms-2"></i> */}
                          </h4>
                          {/* <div className="mini-stat-label bg-danger">
                      <p className="mb-0">- 28%</p>
                    </div> */}
                        </div>
                        {/* <div className="pt-2">
                    <div className="float-end">
                      <Link to="#" className="text-white-50">
                        <i className="mdi mdi-arrow-right h5"></i>
                      </Link>
                    </div>

                    <p className="text-white-50 mb-0 mt-1">Since last month</p>
                  </div> */}
                      </CardBody>
                    </Card>
                  </Col>

                  <Col xl={3} md={6}>
                    <Card className="mini-stat bg-primary text-white">
                      <CardBody>
                        <div className="">
                          <div className="float-start mini-stat-img me-4">
                            <img src={servicesIcon3} alt="" />
                          </div>
                          <Link to="/reviews">
                            <h5
                              className="font-size-14 text-uppercase mt-0 text-white-70"
                              style={{ height: "30px" }}
                            >
                              Reviews
                            </h5>
                          </Link>
                          <h4 className="fw-medium font-size-24">589 </h4>
                        </div>
                      </CardBody>
                    </Card>
                  </Col>

                  <Col xl={3} md={6}>
                    <Card className="mini-stat bg-primary text-white">
                      <CardBody>
                        <div className="">
                          <div className="float-start mini-stat-img me-4">
                            <img src={servicesIcon3} alt="" />
                          </div>
                          <Link to="/total-order">
                            <h5
                              className="font-size-14 text-uppercase mt-0 text-white-70"
                              style={{ height: "30px" }}
                            >
                              Total Orders
                            </h5>
                          </Link>
                          <h4 className="fw-medium font-size-24">15,23,589 </h4>
                        </div>
                      </CardBody>
                    </Card>
                  </Col>
                </Row>
              </CardBody>
            </Card>
          </Row>

          {/* <Row>
            <Card className="bg-dashboard2">
              <CardBody>
                <Row>
                  <h5 className="page-title mb-3">Revenue</h5>
                  <Col xl={3} md={6}>
                    <Card className="mini-stat bg-primary text-white">
                      <CardBody>
                        <div className="">
                          <div className="float-start mini-stat-img me-4">
                            <img src={servicesIcon1} alt="" />
                          </div>
                          <h5
                            className="font-size-14 text-uppercase mt-0 text-white-70"
                            style={{ height: "30px" }}
                          >
                            Today’s Sales
                          </h5>
                          <h4 className="fw-medium font-size-24">
                            589{" "}
                          </h4>
                        </div>
                      </CardBody>
                    </Card>
                  </Col>
                  <Col xl={3} md={6}>
                    <Card className="mini-stat bg-primary text-white">
                      <CardBody>
                        <div className="">
                          <div className="float-start mini-stat-img me-4">
                            <img src={servicesIcon2} alt="" />
                          </div>
                          <h5
                            className="font-size-14 text-uppercase mt-0 text-white-70"
                            style={{ height: "30px" }}
                          >
                            Total Revenue
                          </h5>
                          <h4 className="fw-medium font-size-24">
                            368{" "}
                          </h4>
                        </div>
                      </CardBody>
                    </Card>
                  </Col>
                  <Col xl={3} md={6}>
                    <Card className="mini-stat bg-primary text-white">
                      <CardBody>
                        <div className="">
                          <div className="float-start mini-stat-img me-4">
                            <img src={servicesIcon2} alt="" />
                          </div>
                          <h5
                            className="font-size-14 text-uppercase mt-0 text-white-70"
                            style={{ height: "30px" }}
                          >
                            Today's Orders
                          </h5>
                          <h4 className="fw-medium font-size-24">
                          10,000{" "}
                          </h4>
                        </div>
                      </CardBody>
                    </Card>
                  </Col>
                </Row>
              </CardBody>
            </Card>
          </Row> */}

          <Row>
            <Col xl={8}>
              <Card>
                <CardBody>
                  <h4 className="card-title mb-4">Recent Orders</h4>
                  <div className="Dashboard-Table table-responsive">
                    <table className="table table-hover table-centered table-nowrap mb-0">
                      <thead>
                        <tr>
                          <th scope="col">Order No</th>
                          <th scope="col">Customer Name</th>
                          <th scope="col">contact No</th>
                          <th scope="col">Amount</th>
                          <th scope="col">
                            Status
                          </th>
                          <th scope="col">
                            View
                          </th>
                        </tr>
                      </thead>
                      <tbody>
                        <tr>
                          <th scope="row">14256</th>
                          <td>
                            <div>
                              {/* <img
                                src={user2}
                                alt=""
                                className="avatar-xs rounded-circle me-2"
                              />{" "} */}
                              Pizza
                            </div>
                          </td>
                          <td>+91 7048790899</td>
                          <td align="right">$94</td>
                          <td>
                            <span className="badge bg-warning">Pending</span>
                          </td>
                          <td>
                            <div>
                              <Link onClick={() => {setmodal_center_1(true)}} className="btn btn-primary btn-sm">
                                <i className="fas fa-eye"></i>
                              </Link>
                            </div>
                          </td>
                        </tr>
                        <tr>
                          <th scope="row">14257</th>
                          <td>Brent Shipley</td>
                          <td>+91 7048790899</td>
                          <td align="right">$112</td>
                          <td>
                            <span className="badge bg-warning">Pending</span>
                          </td>
                          <td>
                            <div>
                              <Link to="#" className="btn btn-primary btn-sm">
                                <i className="fas fa-eye"></i>
                              </Link>
                            </div>
                          </td>
                        </tr>
                        <tr>
                          <th scope="row">14258</th>
                          <td>Robert Sitton</td>
                          <td>+91 7048790899</td>
                          <td align="right">$116</td>
                          <td>
                            <span className="badge bg-warning">Pending</span>
                          </td>
                          <td>
                            <div>
                              <Link to="#" className="btn btn-primary btn-sm">
                                <i className="fas fa-eye"></i>
                              </Link>
                            </div>
                          </td>
                        </tr>
                        <tr>
                          <th scope="row">14259</th>
                          <td>Alberto Jackson</td>
                          <td>+91 7048790899</td>
                          <td align="right">$109</td>
                          <td>
                            <span className="badge bg-warning">Pending</span>
                          </td>
                          <td>
                            <div>
                              <Link to="#" className="btn btn-primary btn-sm">
                                <i className="fas fa-eye"></i>
                              </Link>
                            </div>
                          </td>
                        </tr>
                        <tr>
                          <th scope="row">14260</th>
                          <td>David Sanchez</td>
                          <td>+91 7048790899</td>
                          <td align="right">$120</td>
                          <td>
                            <span className="badge bg-warning">Pending</span>
                          </td>
                          <td>
                            <div>
                              <Link to="#" className="btn btn-primary btn-sm">
                                <i className="fas fa-eye"></i>
                              </Link>
                            </div>
                          </td>
                        </tr>
                        <tr>
                          <th scope="row">14261</th>
                          <td>Pizza</td>
                          <td>+91 7048790899</td>
                          <td align="right">$94</td>
                          <td>
                            <span className="badge bg-warning">Pending</span>
                          </td>
                          <td>
                            <div>
                              <Link to="#" className="btn btn-primary btn-sm">
                                <i className="fas fa-eye"></i>
                              </Link>
                            </div>
                          </td>
                        </tr>
                        
                      </tbody>
                    </table>
                  </div>
                </CardBody>
              </Card>
            </Col>
            <Col xl={4}>
              <Card>
                <CardBody>
                  <h4 className="card-title mb-4">Top Selling Products</h4>
                  <div className="Dashboard-Table table-responsive">
                    <table className="table table-hover table-centered table-nowrap mb-0">
                      <thead>
                        <tr>
                          <th scope="col">Product Name</th>
                          <th scope="col">Total Order</th>
                        </tr>
                      </thead>
                      <tbody>
                        <tr>
                          <td>
                            <div>
                              <img
                                src={user2}
                                alt=""
                                className="avatar-xs rounded-circle me-2"
                              />{" "}
                              Pizza
                            </div>
                          </td><th scope="row">14256</th>
                        </tr>
                        <tr>
                          <td>
                            <div>
                              <img
                                src={user2}
                                alt=""
                                className="avatar-xs rounded-circle me-2"
                              />{" "}
                              Pizza
                            </div>
                          </td><th scope="row">14256</th>
                        </tr>
                        <tr>
                          <td>
                            <div>
                              <img
                                src={user2}
                                alt=""
                                className="avatar-xs rounded-circle me-2"
                              />{" "}
                              Pizza
                            </div>
                          </td>
                           <td >14256</td>
                        </tr>
                        <tr>
                          <td>
                            <div>
                              <img
                                src={user2}
                                alt=""
                                className="avatar-xs rounded-circle me-2"
                              />{" "}
                              Pizza
                            </div>
                          </td>
                           <td >14256</td>
                        </tr>
                        <tr>
                          <td>
                            <div>
                              <img
                                src={user2}
                                alt=""
                                className="avatar-xs rounded-circle me-2"
                              />{" "}
                              Pizza
                            </div>
                          </td>
                           <td >14256</td>
                        </tr>
                        <tr>
                          <td>
                            <div>
                              <img
                                src={user2}
                                alt=""
                                className="avatar-xs rounded-circle me-2"
                              />{" "}
                              Pizza
                            </div>
                          </td>
                           <td >14256</td>
                        </tr>
                        <tr>
                          <td>
                            <div>
                              <img
                                src={user2}
                                alt=""
                                className="avatar-xs rounded-circle me-2"
                              />{" "}
                              Pizza
                            </div>
                          </td>
                           <td >14256</td>
                        </tr>
                        <tr>
                          <td>
                            <div>
                              <img
                                src={user2}
                                alt=""
                                className="avatar-xs rounded-circle me-2"
                              />{" "}
                              Pizza
                            </div>
                          </td>
                           <td >14256</td>
                        </tr>
                        <tr>
                          <td>
                            <div>
                              <img
                                src={user2}
                                alt=""
                                className="avatar-xs rounded-circle me-2"
                              />{" "}
                              Pizza
                            </div>
                          </td>
                           <td >14256</td>
                        </tr>
                        <tr>
                          <td>
                            <div>
                              <img
                                src={user2}
                                alt=""
                                className="avatar-xs rounded-circle me-2"
                              />{" "}
                              Pizza
                            </div>
                          </td>
                           <td >14256</td>
                        </tr>
                      </tbody>
                    </table>
                  </div>
                </CardBody>
              </Card>
            </Col>
            {/* <Col xl={4}>
              <Card>
                <CardBody>
                  <h4 className="card-title mb-4">Chat</h4>
                  <div className="chat-conversation">
                    <SimpleBar style={{ height: "365px" }}>
                      <ul
                        className="conversation-list"
                        data-simplebar
                        style={{ maxHeight: "367px" }}
                      >
                        <li className="clearfix">
                          <div className="chat-avatar">
                            <img
                              src={user2}
                              className="avatar-xs rounded-circle"
                              alt="male"
                            />
                            <span className="time">10:00</span>
                          </div>
                          <div className="conversation-text">
                            <div className="ctext-wrap">
                              <span className="user-name">John Deo</span>
                              <p>Hello!</p>
                            </div>
                          </div>
                        </li>
                        <li className="clearfix odd">
                          <div className="chat-avatar">
                            <img
                              src={user3}
                              className="avatar-xs rounded-circle"
                              alt="Female"
                            />
                            <span className="time">10:01</span>
                          </div>
                          <div className="conversation-text">
                            <div className="ctext-wrap">
                              <span className="user-name">Smith</span>
                              <p>
                                Hi, How are you? What about our next meeting?
                              </p>
                            </div>
                          </div>
                        </li>
                        <li className="clearfix">
                          <div className="chat-avatar">
                            <img
                              src={user2}
                              className="avatar-xs rounded-circle"
                              alt="male"
                            />
                            <span className="time">10:04</span>
                          </div>
                          <div className="conversation-text">
                            <div className="ctext-wrap">
                              <span className="user-name">John Deo</span>
                              <p>Yeah everything is fine</p>
                            </div>
                          </div>
                        </li>
                        <li className="clearfix odd">
                          <div className="chat-avatar">
                            <img
                              src={user3}
                              className="avatar-xs rounded-circle"
                              alt="male"
                            />
                            <span className="time">10:05</span>
                          </div>
                          <div className="conversation-text">
                            <div className="ctext-wrap">
                              <span className="user-name">Smith</span>
                              <p>Wow that's great</p>
                            </div>
                          </div>
                        </li>
                        <li className="clearfix odd">
                          <div className="chat-avatar">
                            <img
                              src={user3}
                              className="avatar-xs rounded-circle"
                              alt="male"
                            />
                            <span className="time">10:08</span>
                          </div>
                          <div className="conversation-text">
                            <div className="ctext-wrap">
                              <span className="user-name mb-2">Smith</span>

                              <img
                                src={smimg1}
                                alt=""
                                height="48"
                                className="rounded me-2"
                              />
                              <img
                                src={smimg2}
                                alt=""
                                height="48"
                                className="rounded"
                              />
                            </div>
                          </div>
                        </li>
                      </ul>
                    </SimpleBar>

                    <Row className="mt-3 pt-1">
                      <Col md="9" className="chat-inputbar col-8">
                        <Input
                          type="text"
                          className="chat-input"
                          placeholder="Enter your text"
                        />
                      </Col>
                      <Col md="3" className="chat-send col-4">
                        <div className="d-grid">
                          <Button
                            type="submit"
                            color="success"
                            className="btn-block"
                          >
                            Send
                          </Button>
                        </div>
                      </Col>
                    </Row>
                  </div>
                </CardBody>
              </Card>
            </Col> */}

            <Col xl={8}>
              <Card>
                <CardBody>
                  <h4 className="card-title mb-4">Revenue Chart</h4>
                  <Row>
                    <Col lg={7}>
                      <div>
                        <LineAreaChart />
                      </div>
                    </Col>
                    <Col lg={5}>
                      <Row>
                        <Col md={6}>
                          <div className="text-center">
                            <p className="text-muted mb-4">This month</p>
                            <h3>$34,252</h3>
                            <p className="text-muted mb-5">
                              It will be as simple as in fact it will be
                              occidental.
                            </p>
                            <RadialChart />
                          </div>
                        </Col>
                        <Col md={6}>
                          <div className="text-center">
                            <p className="text-muted mb-4">Last month</p>
                            <h3>$36,253</h3>
                            <p className="text-muted mb-5">
                              It will be as simple as in fact it will be
                              occidental.
                            </p>
                            <Apexdonut />
                          </div>
                        </Col>
                      </Row>
                    </Col>
                  </Row>
                </CardBody>
              </Card>
            </Col>

            <Col xl={4}>
              <Card>
                <CardBody>
                  <h4 className="card-title mb-4">Less Selling Products</h4>
                  <div className="Dashboard-Table table-responsive">
                    <table className="table table-hover table-centered table-nowrap mb-0">
                      <thead>
                        <tr>
                          <th scope="col">Product Name</th>
                          <th scope="col">Total Order</th>
                        </tr>
                      </thead>
                      <tbody>
                        <tr>
                          <td>
                            <div>
                              <img
                                src={user2}
                                alt=""
                                className="avatar-xs rounded-circle me-2"
                              />{" "}
                              Pizza
                            </div>
                          </td><th scope="row">14256</th>
                        </tr>
                        <tr>
                          <td>
                            <div>
                              <img
                                src={user2}
                                alt=""
                                className="avatar-xs rounded-circle me-2"
                              />{" "}
                              Pizza
                            </div>
                          </td><th scope="row">14256</th>
                        </tr>
                        <tr>
                          <td>
                            <div>
                              <img
                                src={user2}
                                alt=""
                                className="avatar-xs rounded-circle me-2"
                              />{" "}
                              Pizza
                            </div>
                          </td>
                           <td >14256</td>
                        </tr>
                        <tr>
                          <td>
                            <div>
                              <img
                                src={user2}
                                alt=""
                                className="avatar-xs rounded-circle me-2"
                              />{" "}
                              Pizza
                            </div>
                          </td>
                           <td >14256</td>
                        </tr>
                        <tr>
                          <td>
                            <div>
                              <img
                                src={user2}
                                alt=""
                                className="avatar-xs rounded-circle me-2"
                              />{" "}
                              Pizza
                            </div>
                          </td>
                           <td >14256</td>
                        </tr>
                        <tr>
                          <td>
                            <div>
                              <img
                                src={user2}
                                alt=""
                                className="avatar-xs rounded-circle me-2"
                              />{" "}
                              Pizza
                            </div>
                          </td>
                           <td >14256</td>
                        </tr>
                        <tr>
                          <td>
                            <div>
                              <img
                                src={user2}
                                alt=""
                                className="avatar-xs rounded-circle me-2"
                              />{" "}
                              Pizza
                            </div>
                          </td>
                           <td >14256</td>
                        </tr>
                        <tr>
                          <td>
                            <div>
                              <img
                                src={user2}
                                alt=""
                                className="avatar-xs rounded-circle me-2"
                              />{" "}
                              Pizza
                            </div>
                          </td>
                           <td >14256</td>
                        </tr>
                        <tr>
                          <td>
                            <div>
                              <img
                                src={user2}
                                alt=""
                                className="avatar-xs rounded-circle me-2"
                              />{" "}
                              Pizza
                            </div>
                          </td>
                           <td >14256</td>
                        </tr>
                        <tr>
                          <td>
                            <div>
                              <img
                                src={user2}
                                alt=""
                                className="avatar-xs rounded-circle me-2"
                              />{" "}
                              Pizza
                            </div>
                          </td>
                           <td >14256</td>
                        </tr>
                      </tbody>
                    </table>
                  </div>
                </CardBody>
              </Card>
            </Col>
          </Row>

          {/* <Row>
            <Col xl={3}>
              <Card>
                <CardBody>
                  <h4 className="card-title mb-4">Sales Report</h4>
                  <div className="cleafix">
                    <p className="float-start">
                      <i className="mdi mdi-calendar me-1 text-primary"></i> Jan
                      01 - Jan 31
                    </p>
                    <h5 className="font-18 text-end">$4230</h5>
                  </div>
                  <div id="ct-donut" className="ct-chart wid pt-4">
                    <Salesdonut />
                  </div>
                  <div className="mt-4">
                    <table className="table mb-0">
                      <tbody>
                        <tr>
                          <td>
                            <span className="badge bg-primary">Desk</span>
                          </td>
                          <td>Desktop</td>
                          <td className="text-end">54.5%</td>
                        </tr>
                        <tr>
                          <td>
                            <span className="badge bg-success">Mob</span>
                          </td>
                          <td>Mobile</td>
                          <td className="text-end">28.0%</td>
                        </tr>
                        <tr>
                          <td>
                            <span className="badge bg-warning">Tab</span>
                          </td>
                          <td>Tablets</td>
                          <td className="text-end">17.5%</td>
                        </tr>
                      </tbody>
                    </table>
                  </div>
                </CardBody>
              </Card>
            </Col>
            <Col xl={4}>
              <Card>
                <CardBody>
                  <h4 className="card-title mb-4">Activity</h4>
                  <ol className="activity-feed">
                    <li className="feed-item">
                      <div className="feed-item-list">
                        <span className="date">Jan 22</span>
                        <span className="activity-text">
                          Responded to need “Volunteer Activities”
                        </span>
                      </div>
                    </li>
                    <li className="feed-item">
                      <div className="feed-item-list">
                        <span className="date">Jan 20</span>
                        <span className="activity-text">
                          At vero eos et accusamus et iusto odio dignissimos
                          ducimus qui deleniti atque...
                          <Link to="#" className="text-success">
                            Read more
                          </Link>
                        </span>
                      </div>
                    </li>
                    <li className="feed-item">
                      <div className="feed-item-list">
                        <span className="date">Jan 19</span>
                        <span className="activity-text">
                          Joined the group “Boardsmanship Forum”
                        </span>
                      </div>
                    </li>
                    <li className="feed-item">
                      <div className="feed-item-list">
                        <span className="date">Jan 17</span>
                        <span className="activity-text">
                          Responded to need “In-Kind Opportunity”
                        </span>
                      </div>
                    </li>
                    <li className="feed-item">
                      <div className="feed-item-list">
                        <span className="date">Jan 16</span>
                        <span className="activity-text">
                          Sed ut perspiciatis unde omnis iste natus error sit
                          rem.
                        </span>
                      </div>
                    </li>
                  </ol>
                  <div className="text-center">
                    <Link to="#" className="btn btn-primary">
                      Load More
                    </Link>
                  </div>
                </CardBody>
              </Card>
            </Col>

            <Col xl={5}>
              <Row>
                <Col md={6}>
                  <Card className="text-center">
                    <CardBody>
                      <div className="py-4">
                        <i className="ion ion-ios-checkmark-circle-outline display-4 text-success"></i>

                        <h5 className="text-primary mt-4">Order Successful</h5>
                        <p className="text-muted">
                          Thanks you so much for your order.
                        </p>
                        <div className="mt-4">
                          <Link to="" className="btn btn-primary btn-sm">
                            Chack Status
                          </Link>
                        </div>
                      </div>
                    </CardBody>
                  </Card>
                </Col>
                <Col md={6}>
                  <Card className="bg-primary">
                    <CardBody>
                      <div className="text-center text-white py-4">
                        <h5 className="mt-0 mb-4 text-white-50 font-size-16">
                          Top Product Sale
                        </h5>
                        <h1>1452</h1>
                        <p className="font-size-14 pt-1">Computer</p>
                        <p className="text-white-50 mb-0">
                          At solmen va esser necessi far uniform myth...{" "}
                          <Link to="#" className="text-white">
                            View more
                          </Link>
                        </p>
                      </div>
                    </CardBody>
                  </Card>
                </Col>
              </Row>
              <Row>
                <Col md={12}>
                  <Card>
                    <CardBody>
                      <h4 className="card-title mb-4">Client Reviews</h4>
                      <p className="text-muted mb-3 pb-4">
                        " Everyone realizes why a new common language would be
                        desirable one could refuse to pay expensive translators
                        it would be necessary. "
                      </p>
                      <div className="float-end mt-2">
                        <Link to="#" className="text-primary">
                          <i className="mdi mdi-arrow-right h5"></i>
                        </Link>
                      </div>
                      <h6 className="mb-0">
                        {" "}
                        <img
                          src={user3}
                          alt=""
                          className="avatar-sm rounded-circle me-2"
                        />{" "}
                        James Athey
                      </h6>
                    </CardBody>
                  </Card>
                </Col>
              </Row>
            </Col>
          </Row> */}

















          {/* --------------------------------Model-------------------------------- */}

          <Modal
            size="lg"
            isOpen={modal_center_1}
            toggle={() => {
              view_ModelView()
            }}
            centered={true}
            className="Model"
          >
            <div className="modal-header">
              <h5 className="modal-title mt-0">Pending Order</h5>
              <Button
                type="button"
                onClick={() => {
                  setmodal_center_1(false)
                }}
                className="close"
                data-dismiss="modal"
                aria-label="Close"
              >
                <span aria-hidden="true">&times;</span>
              </Button>
            </div>
            <div className="modal-body">
              <Row>
                <Col md={3} lg={3} sm={12} className="mb-3">
                  <center>
                    <div>
                      <img className="avatar-lg" alt="veltrix" src={QRCode} />
                    </div>
                  </center>
                </Col>

                <Col md={9} lg={9} sm={12} className="mb-3 row">
                  <Col md={3} lg={3} sm={3}>
                    <Label>
                      <b style={{ fontWeight: 600 }}>Branch Name</b>
                    </Label>
                  </Col>
                  <Col md={1} lg={1} sm={1}>
                    <Label>:</Label>
                  </Col>
                  <Col md={8} lg={8} sm={8}>
                    <Label> Sankalp</Label>
                  </Col>

                  <Col md={3} lg={3} sm={3}>
                    <Label>
                      <b style={{ fontWeight: 600 }}>City Name </b>
                    </Label>
                  </Col>
                  <Col md={1} lg={1} sm={1}>
                    <Label>:</Label>
                  </Col>
                  <Col md={8} lg={8} sm={8}>
                    <Label> Ahmedabad, India</Label>
                  </Col>

                  <Col md={3} lg={3} sm={3}>
                    <Label>
                      <b style={{ fontWeight: 600 }}>Order Date</b>
                    </Label>
                  </Col>
                  <Col md={1} lg={1} sm={1}>
                    <Label>:</Label>
                  </Col>
                  <Col md={8} lg={8} sm={8}>
                    <Label> 16/Jun/2022</Label>
                  </Col>

                  <Col md={3} lg={3} sm={3}>
                    <Label>
                      <b style={{ fontWeight: 600 }}>Order No.</b>
                    </Label>
                  </Col>
                  <Col md={1} lg={1} sm={1}>
                    <Label>:</Label>
                  </Col>
                  <Col md={8} lg={8} sm={8}>
                    <Label>#0003698524</Label>
                  </Col>

                  <Col md={3} lg={3} sm={3}>
                    <Label>
                      <b style={{ fontWeight: 600 }}>Delivery Time</b>
                    </Label>
                  </Col>
                  <Col md={1} lg={1} sm={1}>
                    <Label>:</Label>
                  </Col>
                  <Col md={8} lg={8} sm={8}>
                    <Label>02:00 to 04:00PM</Label>
                  </Col>
                </Col>
              </Row>
              <Row>
                <div className="table-responsive">
                  <Table className="table mb-3">
                    <thead className="table-light" color="btn-primary">
                      <tr>
                        <th style={{ width: "50%" }}>Item Name</th>
                        <th style={{ width: "15%", textAlign: "right" }}>
                          Quantity
                        </th>
                        <th style={{ width: "15%", textAlign: "right" }}>
                          Rate
                        </th>
                        <th style={{ width: "20%", textAlign: "right" }}>
                          Amount
                        </th>
                      </tr>
                    </thead>
                    <tbody>
                      <tr>
                        <td>VadaPav</td>
                        <td style={{ textAlign: "right" }}>2</td>
                        <td style={{ textAlign: "right" }}>100.00</td>
                        <td style={{ textAlign: "right" }}>200.00</td>
                      </tr>
                      <tr>
                        <td>Samosa</td>
                        <td style={{ textAlign: "right" }}>1</td>
                        <td style={{ textAlign: "right" }}>50.00</td>
                        <td style={{ textAlign: "right" }}>50.00</td>
                      </tr>
                      <tr>
                        <td>Pizza</td>
                        <td style={{ textAlign: "right" }}>3</td>
                        <td style={{ textAlign: "right" }}>150.00</td>
                        <td style={{ textAlign: "right" }}>450.00</td>
                      </tr>
                      <tr>
                        <td>PavBhaji</td>
                        <td style={{ textAlign: "right" }}>1</td>
                        <td style={{ textAlign: "right" }}>120.00</td>
                        <td style={{ textAlign: "right" }}>120.00</td>
                      </tr>
                    </tbody>
                  </Table>
                </div>
              </Row>
              <Row>
                <Col md={6} lg={6} sm={12} className="mb-0"></Col>
                <Col md={6} lg={6} sm={12} className="mb-0">
                  <Label
                    md={6}
                    style={{ textAlign: "left", paddingLeft: "15px" }}
                    className="pb-0 pt-0"
                  >
                    <b style={{ fontWeight: 600 }}>Item Total :</b>
                  </Label>
                  <Label
                    md={6}
                    style={{ textAlign: "right", paddingRight: "15px" }}
                    className="pb-0 pt-0"
                  >
                    820.00
                  </Label>
                </Col>
                <Col md={6} lg={6} sm={12} className="mb-0"></Col>
                <Col md={6} lg={6} sm={12} className="mb-0">
                  <Label
                    md={6}
                    style={{ textAlign: "left", paddingLeft: "15px" }}
                    className="pb-0 pt-0"
                  >
                    <b style={{ fontWeight: 600 }}>Discount :</b>
                  </Label>
                  <Label
                    md={6}
                    style={{ textAlign: "right", paddingRight: "15px" }}
                    className="pb-0 pt-0"
                  >
                    82.00
                  </Label>
                </Col>
                <Col md={6} lg={6} sm={12} className="mb-0"></Col>{" "}
                <Col md={6} lg={6} sm={12} className="mb-1">
                  <Label
                    md={6}
                    style={{ textAlign: "left", paddingLeft: "15px" }}
                    className="pb-0 pt-0"
                  >
                    <b style={{ fontWeight: 600 }}>Tax :</b>
                  </Label>
                  <Label
                    md={6}
                    style={{ textAlign: "right", paddingRight: "15px" }}
                    className="pb-0 pt-0"
                  >
                    82.00
                  </Label>
                </Col>
                <Col md={6} lg={6} sm={12} className="mb-0"></Col>
                <Col md={6} lg={6} sm={12} className="mb-0">
                  <hr className="mt-0 mb-0"></hr>
                  <Label
                    md={6}
                    style={{ textAlign: "left", paddingLeft: "15px" }}
                    className="pb-0 pt-0"
                  >
                    <b style={{ fontWeight: 600 }}>Total :</b>
                  </Label>
                  <Label
                    md={6}
                    style={{ textAlign: "right", paddingRight: "15px" }}
                    className="pb-0 pt-0"
                  >
                    820.00
                  </Label>
                  <hr className="mt-0 mb-0"></hr>
                </Col>
                <Col md={12} lg={12} sm={12} className="mt-4">
                  <center>
                    <Button
                      color="waves-light"
                      className="waves-effect waves-light btn btn-outline-primary"
                    >
                      Reject
                    </Button>{" "}
                    &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
                    <Button
                      color="primary"
                      className="btn btn-primary waves-effect waves-light"
                    >
                      Accept
                    </Button>{" "}
                  </center>
                </Col>
              </Row>
            </div>
          </Modal>

        </Container>
      </div>
    </React.Fragment>
  )
}

Dashboard.propTypes = {
  t: PropTypes.any,
}

export default withTranslation()(Dashboard)
